import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {DynamicIdService} from 'shared/_services/dynamic.id.service';
import {ControlTemplate} from '../../_interface/control-template.enum';

@Component({
	selector: 'form-button-checkbox',
	templateUrl: './button-checkbox.component.html',
	styleUrls: ['../button.component.scss']
})
export class ButtonCheckboxComponent implements OnInit {

	@Input()
	id: string = this.dynamicIdService.getId('button-checkbox');

	@Input()
	label: string;

	@Input()
	template: ControlTemplate = ControlTemplate.inline;

	@Input()
	controlGroup: UntypedFormGroup;

	@Input()
	buttonLabels: string[] = [];

	get controlNames() {
		return Object.keys(this.controlGroup.controls);
	}

	ControlTemplate = ControlTemplate;

	constructor(private dynamicIdService: DynamicIdService) {
	}

	ngOnInit(): void {
	}

}
